var SummarySourceType;
(function (SummarySourceType) {
    SummarySourceType["Asset"] = "asset";
    SummarySourceType["Chatroom"] = "chatroom";
    SummarySourceType["Task"] = "task";
    SummarySourceType["Activity"] = "activity";
})(SummarySourceType || (SummarySourceType = {}));
const isSummaryContent = (value) => "contentId" in value;
export { SummarySourceType, isSummaryContent };
